import { render } from "./EventDate.vue?vue&type=template&id=190d9347"
import script from "./EventDate.vue?vue&type=script&lang=js"
export * from "./EventDate.vue?vue&type=script&lang=js"

import "./EventDate.vue?vue&type=style&index=0&id=190d9347&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__